import React, { useEffect, useState } from "react";
import { getCompanyApi, UpdateEmaildata } from "../../../Services/Superadmin/Superadmin";
import Swal from "sweetalert2";

const EmailSmpt = () => {
  const [companiesData, setCompaniesData] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    host: "",
    port: "",
    password: "",
  });

  // handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        EMAIL_USER: formData.email,
        EMAIL_Host: formData.host,
        EMAIL_Port: formData.port,
        EMAIL_PASS: formData.password,
      };

      const res = await UpdateEmaildata(payload);

      if (res.status) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "SMTP details updated successfully!",
          timer: 2500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: res.message || "Something went wrong.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to update SMTP details.",
      });
    }
  };

  // fetch company data from API
  const fetchCompaniesData = async () => {
    try {
      const res = await getCompanyApi({});
      if (res.data) {
        setCompaniesData(res.data);

        // fill formData with API response
        setFormData({
          email: res.data.EMAIL_USER || "",
          host: res.data.EMAIL_Host || "",
          port: res.data.EMAIL_Port || "",
          password: res.data.EMAIL_PASS || "",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to load company data.",
      });
    }
  };

  useEffect(() => {
    fetchCompaniesData();
  }, []);

  return (
    <div
      className="container-fluid "
     
    >
        <div className="card transaction-table custom-bg">
      <div className="row justify-content-center">
        <div className="col-lg-12 col-md-12">
          <div className="card shadow-sm border-0 rounded-4">
            {/* Header */}
            <div className="card-header  border-0 rounded-top-4 px-4 pt-3 pb-2">
                <div>
              <h4 className="mb-0">SMTP Settings</h4>
              <p className="text-muted small mb-0">
                Configure your email server credentials used for system emails
                (OTP, notifications, etc.).
              </p>
              </div>
            </div>
            <hr className="mt-0 mb-0" />

            <div className="card-body px-4 pt-4 pb-4">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter SMTP email"
                      required
                    />
                    <small className="text-muted">
                      This email will be used as the sender.
                    </small>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Host</label>
                    <input
                      type="text"
                      name="host"
                      value={formData.host}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="e.g. smtp.gmail.com"
                    />
                    <small className="text-muted">
                      SMTP server host name.
                    </small>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Port</label>
                    <input
                      type="number"
                      name="port"
                      value={formData.port}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="e.g. 465 or 587"
                    />
                    <small className="text-muted">
                      Common ports: 465 (SSL), 587 (TLS).
                    </small>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Password / App Key</label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter SMTP password"
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowPassword((prev) => !prev)}
                        tabIndex={-1}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                    <small className="text-muted">
                      For some providers (like Gmail), use an App Password.
                    </small>
                  </div>
                </div>

                <div className="mt-4">
                  <button type="submit" className="btn btn-primary">
                    Save SMTP Settings
                  </button>
                </div>
              </form>

              {/* Optional info section */}
              <div className="mt-3 text-muted small">
                <strong>Note:</strong> Ensure these details are correct. Wrong
                SMTP configuration can cause emails to fail silently.
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default EmailSmpt;
